// CP-224 (residual LCP): run `callback` once, when `el` comes within `rootMargin` of the viewport.
// The Detail price chart (chart.js chunk) and route map (leaflet chunk + tiles) sit below the fold on mobile, yet
// they were fetched and evaluated before the LCP paint. Deferring them until they are about to be seen keeps them
// out of the critical path. Both sit in fixed-height boxes, so a later mount moves nothing (no CLS, no visual change).
// Without IntersectionObserver (old browsers, tests) or without an element, the callback runs at once (old behaviour).
// Returns a cancel function (call it on unmount).
export const NEAR_VIEWPORT_MARGIN = '200px 0px';

export function whenNearViewport(el, callback, options = {}) {
  const IO = options.IntersectionObserver !== undefined
    ? options.IntersectionObserver
    : (typeof window !== 'undefined' ? window.IntersectionObserver : undefined);
  let done = false;
  const fire = () => {
    if (done) return;
    done = true;
    callback();
  };
  if (!el || typeof IO !== 'function') {
    fire();
    return () => { done = true; };
  }
  let observer = null;
  try {
    observer = new IO((entries) => {
      if (entries.some((e) => e.isIntersecting || e.intersectionRatio > 0)) {
        observer.disconnect();
        fire();
      }
    }, { rootMargin: options.rootMargin || NEAR_VIEWPORT_MARGIN });
    observer.observe(el);
  } catch (err) {
    fire();
    return () => { done = true; };
  }
  return () => {
    done = true;
    if (observer) observer.disconnect();
  };
}
